import React from "react";
import { translate } from "../../utils/translations/translate";
import Input from "../UI/Input";
import { Dropdown } from "../UI/Dropdown";
import {
  INVOICE_FREQUENCY_OPTIONS,
  PAYMENT_TYPE_OPTIONS,
} from "../../utils/constants";
import { DatePickerInput } from "../UI/DatePicker";
import moment from "moment";
import { StyledCardSection } from "./styles";
const ProjectPoDetails = ({ formik, isReadOnlyMode }) => {
  const { poStartDate, poEndDate, paymentTerms, billRate, invoiceFrequency } = formik.values;
  return (
    <StyledCardSection>
      <h1 className="tma_section-title">{translate("labels.po")}</h1>
      <div className="tma-form_field_content">

        <div className="tma_form-control">
          <DatePickerInput
            id={"poStartDate"}
            name="poStartDate"
            labelText={translate("labels.poStartDate")}
            value={poStartDate}
            onChange={(newDate) => {
              formik.setFieldValue('poStartDate', moment(newDate).format("YYYY-MM-DD"))
            }}
            disablePast={false}
            onBlur={formik.handleBlur}
            error={
              formik.touched.poStartDate &&
              Boolean(formik.errors.poStartDate)
            }
            helperText={
              formik.touched.poStartDate && formik.errors.poStartDate
            }
            disabled={isReadOnlyMode}
          />
        </div>

        <div className="tma_form-control tma_align_label">
          <DatePickerInput
            id="poEndDate"
            name="poEndDate"
            labelText={translate("labels.poEndDate")}
            value={poEndDate}
            disablePast={false}
            onChange={(newDate) => {
              formik.setFieldValue('poEndDate', moment(newDate).format("YYYY-MM-DD"))
            }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.poEndDate &&
              Boolean(formik.errors.poEndDate)
            }
            helperText={
              formik.touched.poEndDate && formik.errors.poEndDate
            }
            disabled={false}
          />
        </div>

        <div className="tma_form-control tma_align_label">
          <Dropdown
            label={translate("labels.paymentTerms")}
            options={PAYMENT_TYPE_OPTIONS}
            id={"tma_po_payments_type"}
            initialValue={paymentTerms}
            key={paymentTerms}
            onChange={({ value }) => {
              formik.setFieldValue("paymentTerms", value);
            }}
            disabled={isReadOnlyMode}
          />
        </div>

        <div className="tma_form-control tma_align_label">
          <Input
            id="billRate"
            name="billRate"
            showInfoToolTip={false}
            labelText={translate("labels.billRate")}
            value={billRate}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            inputProps={{ maxLength: 100 }}
            error={
              formik.touched.billRate &&
              Boolean(formik.errors.billRate)
            }
            helperText={
              formik.touched.billRate && formik.errors.billRate
            }
            disabled={isReadOnlyMode}
          />
        </div>

        <div className="tma_form-control">
          <Dropdown
            label={translate("labels.invoiceFrequency")}
            options={INVOICE_FREQUENCY_OPTIONS}
            id={"tma_po_payments_type"}
            initialValue={invoiceFrequency}
            key={invoiceFrequency}
            onChange={({ value }) => {
              formik.setFieldValue('invoiceFrequency', value);
            }}
            disabled={isReadOnlyMode}
          />
        </div>
        <div className="tma_form-control"></div>
      </div>
    </StyledCardSection>
  );
};

export default ProjectPoDetails;
